import createVueApp from '@phoenix/createVueApp';
import StoreSearchForm from '@maison/components/store/StoreSearchForm.vue';

const app = createVueApp({}, true);
app.component('StoreSearchForm', StoreSearchForm);
app.mount('#phoenix-store-search-form');
